export const USER_LOCALSTOREGE_TMP = 'USER_LOCALSTOREGE_TMP'
export const USER_LOCALSTOREGE_LOGIN = 'USER_LOCALSTOREGE_LOGIN'
export const LIST_CONFIG = 'LIST_CONFIG'
export const LIST_WORKSPACE = 'LIST_WORKSPACE'
export const WORKSPACE_CURRENT = 'WORKSPACE_CURRENT'
export const PROJECT_CURRENT = 'PROJECT_CURRENT'
export const CONFIG_PROJECT = 'ConfigProject'

